import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import UserToReviewCard from "./UserToReviewCard";


// Api Calls
import MissionUserListsAPI from "../../../api/api_calls/MissionUserListsAPI";


function ReviewUsers(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingReview, setLoadingReview] = useState(true);
    const [usersToReviewCount, setUsersToReviewCount] = useState(null);
    const [usersToReview, setUsersToReview] = useState([]);



    useEffect(() => {
        async function getUsersForReview() {
            const result = await MissionUserListsAPI.review_users({ missionId, handleRedirect: navigate });

            if (result.success) {
                setUsersToReview(result.users_to_review)
                setUsersToReviewCount(result.users_to_review ? result.users_to_review.length : 0)
                setLoadingReview(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getUsersForReview();
    }, []);


    // Sort users by updated_at
    // If empty, leave it as is.
    const usersToReviewSorted = !usersToReview ? [] :
        usersToReview.sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at)
        }
        )


    return (
        <>
            <SubHeader title={"Review Users"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <div className="completed-sessions-cards-container">
                    {loadingReview ? <CenteredLoadingIcon /> :
                        usersToReviewCount == 0 ?
                            <div className="gray-text">There are no users ready for review.</div>
                            : usersToReviewSorted.map((mul, index) => {
                                return (
                                    <UserToReviewCard key={index} mul={mul} missionId={missionId} />
                                )
                            }
                            )}
                </div>
            </MissionPageContainer>
        </>

    )

}

export default ReviewUsers;